import axios from 'axios'
import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5 * 60 * 1000,
  // 跨域时候允许携带凭证
  // withCredentials: true,
})
// console.log(process.env, 'ev')

service.interceptors.request.use((config) => {
  const tokenValue = Cookies.get('satoken')
  if (tokenValue) {
    config.headers.satoken = tokenValue
  }
  return config
})

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (response.config.responseType === 'blob') {
      return response
    }
    return res
  },
  (error) => {
    if (error.status === 401) {
      // 判断当前页面是否为 login 页面
      if (!location.pathname.startsWith('/login')) {
        location.href = '/login';
      }
    }
    console.log(error) // for debug
    return Promise.resolve(error)
  },
)

export default service
